import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"
import CsvDownload from 'react-json-to-csv'
import ModalEditObservacao from "./modulofinanceiro/modalobservacaofatura"
import Loader from "react-loader-spinner";

class MatriculasnaopagasAdmin extends Component {



  state = {
    faturas:[],
    search:null,
    idmatriculaobservacao:null,
    ano:parseInt(new Date().getFullYear()),
    btn:true,
    status:1
  }

  
   componentDidMount(){
    
    this.loadfaturapendentes();

  }

  async loadfaturapendentes(){
    const {search,ano,status} = this.state;
    this.setState({
      faturas:[],
      btn:true
    })

    const response = await api.post("/admin/faturas/pendentes", {search,ano, status});

    this.setState({
      faturas:response.data
    })

    if(this.state.faturas){
      this.setState({
        btn:false
      })
    }else{
      this.setState({
        btn:true
      })
    }

  }

  async componentDidUpdate(prevProps, prevState, snapshot){
    
    if(prevState.idmatriculaobservacao!==this.state.idmatriculaobservacao){
      console.log(prevState.idmatriculaobservacao)
    }

    if(prevState.ano!==this.state.ano || prevState.status!==this.state.status ){
      this.loadfaturapendentes();
    }

    return true;
  }


  render() {
    
  
    return (
      
      <React.Fragment>
          <Header />
          <ModalEditObservacao truemodaledit={this.state.idmatriculaobservacao} />

        <div class="container col-lg-10 p-4">     

    
<h4>Mensalidades Não Paga</h4>

 {/* Tables */}
<br></br> 

<label>Ano Atuação </label>
            <select onChange={e => this.setState({ ano: parseInt(e.target.value) })}>
              <option value={2019} selected={this.state.ano==2019}>2019</option>
              <option value={2020} selected={this.state.ano==2020}>2020</option>
              <option value={2021} selected={this.state.ano==2021}>2021</option>
              <option value={2022} selected={this.state.ano==2022}>2022</option>
              <option value={2023} selected={this.state.ano==2023}>2023</option>
              <option value={2024} selected={this.state.ano==2024}>2024</option>
              <option value={2025} selected={this.state.ano==2025}>2025</option>
            </select>
            <br></br>

            
<label>Status Matricula </label>
            <select onChange={e => this.setState({ status: parseInt(e.target.value) })}>
              <option value={-1} selected={this.state.status==-1}>Todos</option>
              <option value={1} selected={this.state.status==1}>Ativa</option>
              <option value={2} selected={this.state.status==2}>Cancelada</option>
              <option value={4} selected={this.state.status==4}>Concluida</option>
              <option value={5} selected={this.state.status==5}>Concluída com Pendência</option>
              <option value={6} selected={this.state.status==6}>Formado</option>
              <option value={7} selected={this.state.status==7}>Ativo Totalmente Paga</option>
            </select>
            <br></br>
<CsvDownload children="Extrair Relatório" class="btn btn-dark" disabled={this.state.btn==true} filename={"matriculas_faturas_naopaga_olgamettig"+new Date().getDate()+'-'+new Date().getMonth()+'-'+new Date().getFullYear()+".csv"} data={this.state.faturas} />
<span>{this.state.faturas.length} mensalidades não pagas</span>
 <table class="table">
  <thead>
  <tr>
      <th class="th-sm">Nº Matricula
    </th>
    <th class="th-sm">Status Matricula
    </th>
      <th class="th-sm">Nome Aluno

    </th>
    <th class="th-sm">CPF

    </th>
    <th class="th-sm">Telefone

    </th>
    
      <th class="th-sm">Nome Curso

      </th>
      <th class="th-sm">Modalidade

      </th>
      <th class="th-sm">Faturas Pedentes

      </th>
      <th class="th-sm">Ação

      </th>


    </tr>
  </thead>
  <tbody>
  {this.state.faturas.map(el => (
    <tr>
    <td>{el.idmatricula}</td>
    <td>{el.status}</td>
    <td>{el.Nome}</td>
    <td>{el.CPF}</td>
    <td>{el.Telefone}</td>
    <td>{el.Curso}</td>
    <td>{el.isead==true?"EAD":"Presencial"}</td>
    <td>{el.faturas_pendentes}</td>


    <td>
      <a  class="btn btn-black btn-sm" onClick={e => this.setState({ idmatriculaobservacao: el.idmatricula })}>Anotação</a>
      <a href={"/admin/faturas/"+el.idmatricula} class="btn btn-info btn-sm">Ver Faturas</a>

    </td>
  </tr>
  ))}
    

  </tbody>
</table>
<Loader
    className="d-flex justify-content-center"
    type="TailSpin"
    color="#00BFFF"
    height={100}
    width={100}
    visible={this.state.btn==true} //3 secs
    />
{/* FIm table */}












    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(MatriculasnaopagasAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/faturasnaopaga.js